import { Grid } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ControlService from "./ReceiptProductsService";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultButton from "../../componentes/button/DefaultButton";
import GridButtonRow from "../../componentes/form-grids/GridButtonRow";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import DefaultCheckBoxSelect from "../../componentes/checkbox-select/DefaultCheckboxSelect";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";

export default function ReceiptProducts () {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialStateHeader = {
        id: 0,
        numberDocument: "",
        dtDocument: null,
        userId: userId,
        products: [],
        cdStatus: 1,
        success: false,
        error: false,
    };

    const initialState = {
        id: 0,
        numberDocument: "",
        dtDocument: null,
        userId: userId,
        cdStatus: 1,
        products: Array(20).fill().map(() => ({
            idProduct: 0,
            productGroup: 0,
            productCode: "",
            productName: "",
            qttyBox:"",
            barCode:"",
        })),
        opcaoValue: true,
        batch: 1,
        message: "",
        success: false,
        error: false,
    };

    const initialStateBody = {
        products: Array(20).fill().map(() => ({
            idProduct: 0,
            productGroup: 0,
            productCode: "",
            productName: "",
            qttyBox:"",
            barCode:"",
        })),
        opcaoValue: true,
        batch: 1
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data, products: action.data.products ?? state.products}
            case "clear":
                return initialState
            case "clearHeader":
                return initialStateHeader
            case "clearBody":
                return initialStateBody
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false, message: "" }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { id, numberDocument, dtDocument, cdStatus, opcaoValue } = state
    const { success, error, rows, rowsProduct, ...data } = state

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } }) 
    }

    const handleChangeProduct = (index, { target: { name, value } }) => {
        const updatedProducts = [...state.products];
        updatedProducts[index][name] = value;
        dispatch({ type: "update", data: { products: updatedProducts } });
    };

    function handleClearHeader() {
        dispatch({ type: "clearHeader" });
    }

    function handleClear() {
        dispatch({ type: "clearBody" });
    }

    const handleSaveHeader = () => {
        if (!numberDocument || dtDocument === null)
        {
            dispatch({ type: 'error' });
            return
        }

        const dtDocumentZeroTime = dtDocument.toISOString().split('T')[0];

        let request = {
            id,
            numberDocument,
            dtDocument: dtDocumentZeroTime,
            userId,
            cdStatus
        };

        ControlService
            .saveHeader(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: {id: response.data.id, 
                        products: state.products.length ? state.products : initialStateBody.products,
                        opcaoValue: initialStateBody.opcaoValue } })
                }
            })
            .catch((e) => dispatch({ type: 'error' }));
    }

    const handleSendPrint = () => {

        if (!numberDocument || dtDocument === null)
        {
            dispatch({ type: 'error' });
            return
        }

        let request = {
            ...data,
            batch: opcaoValue ? 1 : 0, 
            products: state.products.map(p => ({
                ...p,
                qttyBox: p.qttyBox ? Number(p.qttyBox) : 0,
                productCode: p.productCode,
                idProduct: p.idProduct
            })),
        
        };

        ControlService
            .sendPrint(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ 
                        type: 'update', 
                        data: { 
                            success: true, 
                            error: false, 
                            message: t("labelSendToPrint")
                        } 
                    })
                }
            })
            .catch((e) => dispatch({ type: 'error' }));
    }

    const canPrint = () => {
        let verify = true;
        
        state.products.forEach((product, index) => {
            if (product.productCode && !product.qttyBox) {
                verify = false;
            }
        });

        if (!verify)
        {
            dispatch({ type: 'error' })
        }
        return verify;
    };
        
    const handleSave = () => {
        if (!canPrint())
        {
            return;
        }

        let request = {
            ...data,
            batch: opcaoValue ? 1 : 0, 
            products: state.products.map(p => ({
                ...p,
                qttyBox: p.qttyBox ? Number(p.qttyBox) : 0,
                productCode: p.productCode,
                idProduct: p.idProduct
            })),
        
        };
            
        ControlService
            .saveItens(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'clearBody' })
                    dispatch({ type: 'success' })
                }
            })
            .catch((e) => dispatch({ type: 'error' }));
    };

    useEffect(() => {
        state.products.forEach((product, index) => {
            if (product.productCode && !product.productName) { 
                // Só busca se o código existe e o nome ainda não foi preenchido
                handleCodeProduct(index, product.productCode);
            }
        });
    }, [state.products.map(p => p.productCode).join(",")]);

    useEffect(() => {
        state.products.forEach((product, index) => {
            if (product.barCode && !product.productName) { 
                // Só busca se o código de barras existe e o nome ainda não foi preenchido
                handleBarCode(index, product.barCode);
            }
        });
    }, [state.products.map(p => p.barCode).join(",")]);

    useEffect(() => {
        state.products.forEach((product, index) => {
            if (product.productName && product.idProduct === 0) { 
                // Só busca se o código de barras existe e o nome ainda não foi preenchido
                handleProductName(index, product.productName);
            }
        });
    }, [state.products.map(p => p.productName).join(",")]);


    const handleCodeProduct = (index, code) => {
        const product = state.products[index]; // pega o produto da linha
        let request = { 
            productCode: code, 
            productGroup: product.productGroup  // usa o grupo específico
        };

        ControlService
            .getByCodeProduct(request)
            .then((response) => {
                if (response.data) {
                    const updatedProducts = [...state.products];
                    updatedProducts[index] = {
                        ...updatedProducts[index],
                        idProduct: response.data.idProduct,
                        barCode: response.data.barCode,
                        productName: response.data.productName
                    };
                    dispatch({ type: 'update', data: { products: updatedProducts } });
                }
            })
            .catch(() => {});
    };

    const handleBarCode = (index, code) => {
        const product = state.products[index]; // pega o produto da linha
        let request = { 
            barCode: code, 
            productGroup: product.productGroup  // usa o grupo específico
        };

        ControlService
            .getByBarCode(request)
            .then((response) => {
                if (response.data) {
                    const updatedProducts = [...state.products];
                    updatedProducts[index] = {
                        ...updatedProducts[index],
                        idProduct: response.data.idProduct,
                        productCode: response.data.productCode,
                        productName: response.data.productName
                    };
                    dispatch({ type: 'update', data: { products: updatedProducts } });
                }
            })
            .catch(() => {});
    };

    const handleProductName = (index, code) => {
        const product = state.products[index]; // pega o produto da linha
        let request = { 
            productName: code, 
            productGroup: product.productGroup  // usa o grupo específico
        };

        ControlService
            .getByProductName(request)
            .then((response) => {
                if (response.data) {
                    const updatedProducts = [...state.products];
                    updatedProducts[index] = {
                        ...updatedProducts[index],
                        idProduct: response.data.idProduct,
                        productCode: response.data.productCode,
                        barCode: response.data.barCode
                    };
                    dispatch({ type: 'update', data: { products: updatedProducts } });
                }
            })
            .catch(() => {});
    };

    const opcao = [{ name: "opcaoValue", text: t("labelsByBatch"), value: opcaoValue }]

    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        message={state.message}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="description" labelName="numberDocument" />
                                }
                                name="numberDocument"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={numberDocument}
                                inputProps={{ maxLength: 20 }}
                                error={error && numberDocument === ""}
                                disabled={state.id !== 0}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <CustomDatePicker
                                id="dtDocument"
                                name="dtDocument"
                                selectedDate={dtDocument}
                                handleChange={handleChange}
                                error={error && dtDocument === null}
                                disabled={state.id !== 0}
                            />
                        </Grid>
                    </GridInputRow>

                    <GridButtonRow>
                        <Grid item xs={4} sm={3} md={3}>
                            <DefaultButton labelName={t("saveHeader")} className="primaryButton" onClick={handleSaveHeader} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={3}>
                            <DefaultButton labelName={t("clearHeader")} className="primaryButton" onClick={handleClearHeader} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={3}>
                            <DefaultButton labelName={t("sendPrint")} disabled={state.id === 0}  className="primaryButton" onClick={handleSendPrint} />
                        </Grid>
                    </GridButtonRow>


                    {Number(id) !== 0 ?
                        <>
                        {state.products.map((product, index) => (
                            <GridInputRow key={index}>
                                <Grid item xs={12} sm={6} md={2}>
                                    <DefaultAutocomplete
                                        name={"productGroup"}
                                        onChange={(e) => handleChangeProduct(index, e)}
                                        placeholder={t("productGroup")}
                                        label={t("productGroup")}
                                        useApi
                                        endpoint='GetProductGroupListAutoComplete'
                                        value={product.productGroup}
                                        defaultSize
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={2}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="productCode" />
                                        }
                                        name="productCode"
                                        control={control}
                                        defaultValue=""
                                        label={t("productCode")}
                                        onChange={(e) => handleChangeProduct(index, e)}
                                        value={product.productCode}
                                        length={30}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="barCode" />
                                        }
                                        name="barCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={(e) => handleChangeProduct(index, e)}
                                        value={product.barCode}
                                        length={30}
                                        label={t("barCode")}
                                        error={error && product.productCode && product.barCode === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="product" labelName="productName" />
                                        } 
                                        name="productName"
                                        control={control}
                                        defaultValue=""
                                        onChange={(e) => handleChangeProduct(index, e)}
                                        value={product.productName}
                                        label={t("productName")}
                                        length={100}
                                        error={error && product.productCode && product.productName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2} md={2}>
                                    
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="qtty" labelName="qttyBox" />
                                        }
                                        name="qttyBox"
                                        control={control}
                                        defaultValue=""
                                        onChange={(e) => handleChangeProduct(index, e)}
                                        label={t("qtdeBox")}
                                        value={product.qttyBox}
                                        length={10}
                                        inputProps={{ type: "number" }}
                                        error={error && product.productCode && product.qttyBox === ""}
                                    />
                                    
                                </Grid>
                            </GridInputRow>
                        ))}

                        <GridInputRow>
                            <Grid item xs={12} sm={6} md={2}>
                                <DefaultCheckBoxSelect
                                    name="generate"
                                    list={opcao}
                                    onChange={handleChange}
                                    spacing={12} // ocupa a linha inteira
                                    error={false}
                                />
                            </Grid>
                            
                            <Grid item xs={4} sm={3} md={3}>
                                <DefaultButton labelName={t("clearItens")} className="primaryButton" onClick={handleClear} />
                            </Grid>

                            <Grid item xs={4} sm={3} md={3}>
                                <DefaultButton labelName={t("saveItens")} className="primaryButton" onClick={handleSave} />
                            </Grid>
                        </GridInputRow>
                        </>
                    : null}

                </GridItemContainer>
            } />
    );
}